<template>
  <v-container grid-list-xs class="pa-0">
    <v-slide-group class="py-0 my-1" center-active mandatory v-model="model">
      <v-slide-item
        v-for="item in statusMission"
        :key="item.id"
        v-slot="{ active, toggle }"
        class="mb-2"
        @change="gotoMissionFilter(item)"
      >
        <v-card
          :color="active ? site.color : ''"
          rounded="lg"
          class="mx-1 py-2"
          elevation="5"
          width="50%"
          :key="keyComponent"
          @click="toggle"
        >
          <p
            :style="{ 'font-size': '11px' }"
            class="pa-0 mb-0 text-center black--text"
            :class="active ? 'white--text' : site.color"
          >
            {{ changeStatus(item) }}
          </p>
          <p
            class="text-h5 mb-0 text-center py-0"
            :style="{ color: site.color }"
            :class="active ? 'white--text' : site.color"
          >
            {{ item.count }}
          </p>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </v-container>
</template>

<script>
export default {
  props: ["statusMission", "site", "status"],

  data() {
    return {
      model: this.status + 1,
      keyComponent: 0,
    };
  },

  methods: {
    gotoMissionFilter(item) {
      this.$emit("gotoMissionFilter", item);
    },
    changeStatus(missionText) {
      return this.$t(missionText.mission_status_text);
      
    },
  },
};
</script>

<style lang="scss" scoped></style>
